import React from "react";
import "../styles/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy – Squarefeet Marble</h1>

      <section>
        <h2>What We Do With Your Information?</h2>
        <p>
          When you purchase something from our store, as part of the buying and
          selling process, we collect the personal information you give us such
          as your name, address and email address. When you browse our store, we
          also automatically receive your computer’s internet protocol (IP)
          address in order to provide us with information that helps us learn
          about your browser and operating system.
        </p>

        <p>
          <strong>Email marketing (if applicable):</strong> With your
          permission, we may send you emails about our store, new products and
          other updates.
        </p>
      </section>

      <section>
        <h2>Consent – How Do You Get My Consent?</h2>
        <p>
          When you provide us with personal information to complete a
          transaction, verify your credit card, place an order, arrange for a
          delivery or return a purchase, we imply that you consent to our
          collecting it and using it for that specific reason only.
        </p>

        <p>
          If we ask for your personal information for a secondary reason, like
          marketing, we will either ask you directly for your expressed consent,
          or provide you with an opportunity to say no.
        </p>

        <h3>How Do I Withdraw My Consent?</h3>
        <p>
          If after you opt-in, you change your mind, you may withdraw your
          consent for us to contact you, for the continued collection, use or
          disclosure of your information, at any time, by contacting us.
        </p>
      </section>

      <section>
        <h2>Disclosure</h2>
        <p>
          We may disclose your personal information if we are required by law to
          do so or if you violate our Terms of Service.
        </p>
      </section>

      <section>
        <h2>Payment</h2>
        <p>
          We use Razorpay for processing payments. We/Razorpay do not store your
          card data on their servers. The data is encrypted through the Payment
          Card Industry Data Security Standard (PCI-DSS) when processing payment.
          Your purchase transaction data is stored only as long as necessary to
          complete your purchase transaction.
        </p>

        <p>
          Razorpay adheres to the standards set by PCI-DSS as managed by the PCI
          Security Standards Council, which is a joint effort of brands like
          Visa, MasterCard, American Express and Discover.
        </p>

        <p>
          Read more at{" "}
          <a
            href="https://razorpay.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://razorpay.com
          </a>
        </p>
      </section>

      <section>
        <h2>Third-Party Services</h2>
        <p>
          In general, third-party providers used by us will only collect, use
          and disclose your information to the extent necessary to allow them
          to perform the services they provide to us.
        </p>

        <p>
          Once you leave our website or are redirected to a third-party website
          or application, you are no longer governed by this Privacy Policy or
          our website’s Terms of Service.
        </p>
      </section>

      <section>
        <h2>Links</h2>
        <p>
          When you click on links on our store, they may direct you away from our
          site. We are not responsible for the privacy practices of other sites
          and encourage you to read their privacy statements.
        </p>
      </section>

      <section>
        <h2>Security</h2>
        <p>
          To protect your personal information, we take reasonable precautions
          and follow industry best practices to make sure it is not
          inappropriately lost, misused, accessed, disclosed, altered or
          destroyed.
        </p>
      </section>

      <section>
        <h2>Cookies</h2>
        <p>
          We use cookies to maintain the session of your user. We do not use
          cookies to personally identify you on other websites.
        </p>
      </section>

      <section>
        <h2>Age of Consent</h2>
        <p>
          By using this site, you represent that you are at least the age of
          majority in your state or province of residence, or that you are the
          age of majority and have given us your consent to allow any of your
          minor dependents to use this site.
        </p>
      </section>

      <section>
        <h2>Changes to This Privacy Policy</h2>
        <p>
          We reserve the right to modify this privacy policy at any time, so
          please review it frequently. Changes and clarifications will take
          effect immediately upon their posting on the website.
        </p>

        <p>
          If our store is acquired or merged with another company, your
          information may be transferred to the new owners so that we may
          continue to sell products to you.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
